import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './fade_out_link.less'

class FadeOutLink extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    href: PropTypes.string.isRequired,
  }

  handleBodyTransitionEnd = event => {
    if (event.target === document.body) {
      document.body.removeEventListener(
        'transitionend',
        this.handleBodyTransitionEnd
      )
      location.href = this.props.href
    }
  }

  handleClick = e => {
    e.preventDefault()

    document.body.classList.add(styles['fade-out'])
    document.body.addEventListener(
      'transitionend',
      this.handleBodyTransitionEnd
    )
  }

  render() {
    let propsToTransfer = { ...this.props }
    delete propsToTransfer.styles

    return (
      <a onClick={this.handleClick} {...propsToTransfer}>
        {this.props.children}
      </a>
    )
  }
}

export default cssModules(FadeOutLink, styles)
